import { render, staticRenderFns } from "./MoreInformation.vue?vue&type=template&id=4e835b02&scoped=true&"
import script from "./MoreInformation.vue?vue&type=script&lang=js&"
export * from "./MoreInformation.vue?vue&type=script&lang=js&"
import style0 from "./MoreInformation.vue?vue&type=style&index=0&id=4e835b02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e835b02",
  null
  
)

export default component.exports